'use client'
import { useEffect, useState } from 'react'
import WebsiteNotFoundPage from '@/app/not-found'

export default function Page() {
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    const url = window.location

    if (
      url.origin.includes('fatura.atplus.digital') &&
      (url.pathname === '/' || url.pathname === '')
    ) {
      // Realizar recarga completa na nova rota para inicializar corretamente tema e estado
      window.location.replace(`/website/a9JkT2vXqL7sWmP5zR4Ye/public-area`)
      return
    }
    if (
      url.origin.includes('cliente.atplus.digital') &&
      (url.pathname === '/' || url.pathname === '')
    ) {
      // Realizar recarga completa na nova rota para inicializar corretamente tema e estado
      window.location.replace(`/website/a9JkT2vXqL7sWmP5zR4Ye`)
      return
    }
    if (
      url.origin.includes('central.zentelecom.com.br') &&
      (url.pathname === '/' || url.pathname === '')
    ) {
      // Realizar recarga completa na nova rota para inicializar corretamente tema e estado
      window.location.replace(`/website/cRGTzm2S5kgPeTm-Ufq20`)
      return
    }

    // falha na validação: exibir página de não encontrado
    setNotFound(true)
    setLoading(false)
  }, [])

  if (loading) return null
  if (notFound) return <WebsiteNotFoundPage />
  return null
}
